import { GlobalOutlined } from '@ant-design/icons';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema';
import { AsyncSelectConfigComponent } from './AsyncSelectConfigComponent';
import { AsyncSelectConfigSchema } from './AsyncSelectConfigSchema';
import { AsyncSelectWidgetComponent } from './AsyncSelectWidgetComponent';
import { AsyncSelectWidgetPreview } from './AsyncSelectWidgetPreview';
import { IAsyncSelectWidget } from './IAsyncSelectWidget';
import { createAsyncSelectFormSchema } from './createAsyncSelectFormSchema';
import { getAsyncSelectOutputReferences } from './getAsyncSelectOutputReferences';
import { getAsyncSelectWidgetReference } from './getAsyncSelectWidgetReference';
import { hydrateAsyncWidget } from './utils/hydrateAsyncWidget';

export const AsyncSelectWidgetType: IWidgetType<IAsyncSelectWidget> = {
  type: WidgetType.AsyncSelect,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Campo scelta da servizio',
  icon: <GlobalOutlined />,
  getReference: getAsyncSelectWidgetReference,
  getSiblingReferences: getAsyncSelectOutputReferences,
  hasValue: true,
  formComponent: AsyncSelectWidgetComponent,
  createFormSchema: createAsyncSelectFormSchema,
  previewComponent: AsyncSelectWidgetPreview,
  configValidator: AsyncSelectConfigSchema,
  configComponent: AsyncSelectConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  configOptions: {
    removeCollapsePanel: true,
  },
  rules: [RequiredRule, CustomWarningsRule],
  /**
   * Per le async select nell'hydrate ritorno, come valore
   * non il value del widget, ma la label mostrata all'utente,
   * così da poter valorizzare correttamente il pdf.
   */
  hydrate: hydrateAsyncWidget,
};
